import { TableStatusCourseComponent } from "src/app/shared/components/table-status-course/table-status-course.component"
import { ReportsBoxComponent } from "./../components/reports-box/reports-box.component"
import { ProgressBarComponent } from "./../components/progress-bar/progress-bar.component"
import { PreloaderComponent } from "./../components/preloader/preloader.component"
import { TableOrderComponent } from "./../components/order/table-order.component"
import { ModificationModalComponent } from "./../components/modification-modal/modification-modal.component"
import { ModalWarningComponent } from "./../components/modal-warning/modal-warning.component"
import { ModalInfoComponent } from "src/app/shared/components/modal-info/modal-info.component"
import { LexTableComponent } from "src/app/shared/components/lex-table/lex-table.component"
import { LexPillComponent } from "./../components/lex-pill/lex-pill.component"
import { IconTextComponent } from "./../components/icon-text/icon-text.component"
import { GridTagsComponent } from "./../components/grid-tags/grid-tags.component"
import { FormTableComponent } from "./../components/form-table-component/form-table-component.component"
import { FoldableContentComponent } from "src/app/shared/components/foldable-content/foldable-content.component"
import { DigitalUsageTableComponent } from "./../components/digital-usage-table/digital-usage-table.component"
import { DatepickerComponent } from "./../components/datepicker/datepicker.component"
import { ConfirmationComponent } from "src/app/shared/components/confirmation/confirmation.component"
import { ButtonsFormCompletionComponent } from "./../components/buttons-form-completion/buttons-form-completion.component"
import { AlertAppActionComponent } from "src/app/shared/components/alert-app-action/alert-app-action.component"
import { AccordionComponent } from "./../components/accordion/accordion.component"
import { ModalComponent } from "src/app/shared/components/modal/modal.component"
import { TitlebarComponent } from "./../components/titlebar/titlebar.component"
import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { MaskedDirective } from "../directive/masked.directive"
import { NgxMaskModule } from "ngx-mask"
import { NgbModule, NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap"
import { FileUploadModule } from "ng2-file-upload"
import { TablePagginationComponent } from "../components/paggination/table-paggination.component"
import { TrimOnBlurDirective } from "../directive/trim-on-blur.directive"
import { ImgDefaultDirective } from "../directive/img-default.directive"
import { NgSelectModule } from "@ng-select/ng-select"
import { LexModalWithInputToCopyDataComponent } from "../components/lex-modal-with-input-to-copy-data/lex-modal-with-input-to-copy-data.component"
import { IntlInputComponent } from "../components/intl-input/intl-input.component"
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { LexButtonComponent } from "../components/lex-button/lex-button.component"
import { LexModalComponent } from "../components/lex-modal/lex-modal.component"
import { LexSelectComponent } from "../components/lex-select/lex-select.component"
import { CapitalizePipe } from "../Pipes/capitalize.pipe"
import { ModalSubjectDeleteComponent } from "../components/modal-delet-subject/modal-subject-delete.component"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"
import { LoaderComponent } from "../components/loader/loader.component"
import { AccessCardComponent } from "../components/access-card/access-card.component"
import { WrapperAccessCardComponent } from "../components/wrapper-access-card/wrapper-access-card.component"
import { CpfPipe } from "../Pipes/cpf.pipe"
import { MatIconModule } from "@angular/material/icon"
import { StatusLegendComponent } from "../components/status-legend/status-legend.component"
import { WrapperGroupAccessCardComponent } from "../components/wrapper-group-access-card/wrapper-group-access-card.component"
import { FeedbackDialogComponent } from "../components/feedback-dialog/feedback-dialog.component"
import { MatDialogModule } from "@angular/material/dialog"
import { MatButtonModule } from "@angular/material/button"

const components = [
  AccordionComponent,
  AlertAppActionComponent,
  ButtonsFormCompletionComponent,
  ConfirmationComponent,
  DatepickerComponent,
  DigitalUsageTableComponent,
  FoldableContentComponent,
  FormTableComponent,
  GridTagsComponent,
  IconTextComponent,
  LexPillComponent,
  LexTableComponent,
  ModalComponent,
  ModalInfoComponent,
  ModalWarningComponent,
  ModificationModalComponent,
  TableOrderComponent,
  PreloaderComponent,
  ProgressBarComponent,
  ReportsBoxComponent,
  TableStatusCourseComponent,
  TitlebarComponent,
  MaskedDirective,
  TablePagginationComponent,
  LexModalWithInputToCopyDataComponent,
  IntlInputComponent,
  LexButtonComponent,
  LexModalComponent,
  LexSelectComponent,
  ModalSubjectDeleteComponent,
  LoaderComponent,
  AccessCardComponent,
  WrapperAccessCardComponent,
  StatusLegendComponent,
  WrapperGroupAccessCardComponent,
  FeedbackDialogComponent,
]

const directives = [TrimOnBlurDirective, ImgDefaultDirective]

const pipes = [CapitalizePipe, CpfPipe]

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
  ],
  declarations: [...components, ...directives, ...pipes],
  exports: [...components, ...directives, ...pipes],
})
export class SharedComponentsModule {}
